// extracted by mini-css-extract-plugin
export var growableInput = "_8q-0";
export var tagContainer = "_8q-2";
export var textInput = "_8q-1";